import { OreDivider, OreHeading, OreStack } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { PageWrapper } from '@/Shared/ui/layout'
import {
  ChangeLanguage,
  DeleteAccount,
  MyUserData,
  PasswordChanger,
} from '@/User/ui/organisms'
import { configurationTranslation } from '@/User/ui/userTranslation'

export const ConfigurationPage = (): JSX.Element => {
  const { t } = useTranslation()
  return (
    <PageWrapper
      paddingTop={8}
      style={{
        paddingRight: 40,
        paddingLeft: 40,
        minWidth: '-webkit-fill-available',
        marginRight: 0,
        marginLeft: 0,
      }}
    >
      <OreHeading as="h1" size="title-sm">
        {t(configurationTranslation.title)}
      </OreHeading>
      <OreDivider space="larger-bottom" />
      <OreStack space="xlarge">
        <OreStack
          space="xlarge"
          direction="row"
          placeContent="stretch"
          placeItems="stretch"
          sameSize
        >
          <MyUserData />
          <PasswordChanger />
        </OreStack>
        <OreStack
          space="xlarge"
          direction="row"
          placeContent="stretch"
          placeItems="stretch"
          sameSize
        >
          <ChangeLanguage />
          <DeleteAccount />
        </OreStack>
      </OreStack>
    </PageWrapper>
  )
}
